import * as S from "./style";
import { useEffect, useState } from "react";
import axiosInstance from "services/axiosInstance";
//Interface
import { ICard } from "Interfaces/ICard";
//Utils
import { CurrencyFormat } from "utils/CurrencyFormat";

interface ICreat {
  subtotal: number;
  register: any,
  errors: any,
  reset: any,
  resetField: any,
  index: number,
  setValue?: any,
  responsaData: (
    id: number,
    taxa: string,
    parcela: number
  ) => void
}

export default function CreditCard({
  subtotal,
  register,
  errors,
  index = 0,
  responsaData
}: ICreat) {
  const [card, setCard] = useState<ICard[]>([]);
  /**
   * Retorna o valor do total + a taxa da parcela.
   * @param total
   * @param numberInstallm
   * @returns {number}
   */
  const calculateInstallments = (installm: number) => {
    const total = subtotal;
    const result = total + (total * installm / 100);
    return result;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("find-all");
        setCard(response.data);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchData();
  }, []);

  const ModalSelected = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedOption = e.target.selectedOptions[0]; // pega o <option> escolhido
    const id = Number(e.target.value); // value (id da parcela)
    const interestRate = selectedOption.getAttribute("data-interest_rate") || '0'; // taxa
    const numberInstallment = Number(selectedOption.getAttribute("data-installment") || 0); // taxa

    responsaData(id, interestRate, numberInstallment);
  };


  return (
    <S.Container>
      <S.Content>
        <S.SeparateDiv>
          <S.FormInput>
            <S.Label htmlFor="qtd_installment">
              Parcelas <span>*</span>
            </S.Label>

            <S.Select
              id={`installment_on_credit_card_id.${index}`}
              {...register(`installment_on_credit_card_id.${index}`, { required: true })}
              onChange={(e) => ModalSelected(e)}
            >
              <option value="" disabled selected hidden>
                Selecione
              </option>
              {
                card.map((val, index) => {
                  const value = index + 1;
                  const value_id = val.id;

                  const totalWithInterest = calculateInstallments(Number(val.interest_rate));

                  const installmentValue = CurrencyFormat(totalWithInterest / val.number_installment);
                  return (
                    <option
                      key={value_id}
                      value={value_id}
                      id={val.interest_rate}
                      data-interest_rate={val.interest_rate}
                      data-installment={val.number_installment}
                    >
                      {val.number_installment}x {installmentValue} - total: {CurrencyFormat(totalWithInterest)}
                    </option>
                  )
                })
              }
            </S.Select>

            {errors[`installment_on_credit_card_id.${index}`] && <S.InforErro>Campo Obrigatório</S.InforErro>}
          </S.FormInput>
        </S.SeparateDiv>
      </S.Content>
    </S.Container>
  );
}
